export enum DiotType {
  'Proovedor Nacional' = '04',
  'Proovedor Extranjero' = '05',
  'Proovedor Global' = '15',
}
